import Contacts from "pages/dashboard/contacts/Contacts";

const CONTACTS_ROUTES = [
  {
    path: "contacts",
    children: [
      {
        path: "",
        element: <Contacts />,
      },
    ],
  },
];

export default CONTACTS_ROUTES;
